<template>
  <div class="ws-info-belongs-to-many">
    <template v-if="relationPopup">
      <div
        v-for="(belongsToManyItem,belongsToManyItemKey) in value"
        :key="belongsToManyItemKey"
        class="ws-info-belongs-to-many__item"
      >
        <WsPopupModel
          :value="belongsToManyItem"
          :fields="_fields"
          :textKey="textKey"
          :getText="getText"
          :modelName="modelName"
          :id="belongsToManyItem.id"
        ></WsPopupModel>
      </div>
    </template>
    <template v-else>
      <div class="ws-info-belongs-to-many__item">
        {{_valueText}}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    $_getValue(value, textKey) {
      if (!this.value) {
        return null;
      }
      if (this.getText) {
        return this.getText(value);
      } else {
        return value[textKey];
      }
    },
  },
  computed: {
    _valueText() {
      let _valueText = "";
      this.value.forEach((valueItem, valueIndex) => {
        if (valueIndex > 0) {
          _valueText += ", ";
        }
        _valueText += this.$_getValue(valueItem, this.textKey);
      });
      return _valueText;
    },
    _fields() {
      if (this.$store.state.model[this.modelName]) {
        return this.$store.state.model[this.modelName].fields;
      } else {
        return null;
      }
    },
  },
  props: {
    getText: {
      type: Function,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    relationPopup: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      default: null,
    },
    value: {
      type: Array,
      default: null,
    },
    textKey: {
      type: String,
      default: "name",
    },
  },
};
</script>

<style>
</style>